export default "__VITE_ASSET__7HBbf2Rx__"